import { useState } from "react";
import { Card, Row, Col, Button, Collapse } from "react-bootstrap";
import {
  FiDownload,
  FiTrash2,
  FiChevronDown,
  FiPlus,
} from "react-icons/fi";

const FilesSection = () => {
  const [open, setOpen] = useState(true);
  const [files, setFiles] = useState([
    {
      name: "Project_1.docx",
      size: "7.6 MB",
      img: "/assets/img/icons/file-02.svg",
      user: "/assets/img/profiles/avatar-02-1.jpg",
      date: "15 May 2024, 6:53 PM",
    },
    {
      name: "Proposal.pdf",
      size: "12.6 MB",
      img: "/assets/img/icons/file-01.svg",
      user: "/assets/img/users/user-19.jpg",
      date: "15 May 2024, 6:53 PM",
    },
    {
      name: "Logo-Img.zip",
      size: "6.2 MB",
      img: "/assets/img/icons/file-04.svg",
      user: "/assets/img/users/user-20.jpg",
      date: "15 May 2024, 6:53 PM",
    },
  ]);

  // FILE UPLOAD
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const newFile = {
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(1) + " MB",
      img: "/assets/img/icons/file-02.svg",
      user: "/assets/img/profiles/avatar-02-1.jpg",
      date: new Date().toLocaleString(),
    };

    setFiles([newFile, ...files]);
  };

  return (
    <Card className="custom-card mb-3 mt-2">
      <Card.Body>

        {/* HEADER */}
        <div className="files-header">
          <h6>Files</h6>

          <div className="d-flex align-items-center gap-2">
            <label className="btn-orange btn-sm mb-0">
              <FiPlus /> Add New
              <input
                type="file"
                hidden
                onChange={handleFileChange}
              />
            </label>

            <FiChevronDown
              className={`accordion-icon ${open ? "rotate" : ""}`}
              onClick={() => setOpen(!open)}
            />
          </div>
        </div>

        {/* CONTENT */}
        <Collapse in={open}>
          <div>
            <Row className="g-3 mt-1">
              {files.map((file, i) => (
                <Col xl={4} md={6} key={i}>
                  <div className="file-card">

                    {/* TOP */}
                    <div className="file-top">
                      <div className="d-flex align-items-center gap-2">
                        <img src={file.img} className="file-icon" />
                        <div>
                          <h6 className="file-name">{file.name}</h6>
                          <small>{file.size}</small>
                        </div>
                      </div>

                      <div className="file-actions">
                        <FiDownload />
                        <FiTrash2
                          onClick={() =>
                            setFiles(files.filter((_, idx) => idx !== i))
                          }
                        />
                      </div>
                    </div>

                    {/* BOTTOM */}
                    <div className="file-bottom">
                      <span>{file.date}</span>
                      <img src={file.user} className="avatar-sm" />
                    </div>

                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Collapse>

      </Card.Body>
      <style>
        {
          `
          .custom-card{
          
          border-radius:6px;
border:1px solid #e5e7eb;
background:#ffffff;
          }
          .files-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordion-icon {
  cursor: pointer;
  transition: 0.3s;
}

.accordion-icon.rotate {
  transform: rotate(180deg);
}

/* FILE CARD */
.file-card {
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 12px;
  background: #fff;
}

/* TOP */
.file-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 8px;
}

.file-icon {
  width: 30px;
}

.file-name {
  font-size: 14px;
  margin: 0;
}

/* ACTIONS */
.file-actions svg {
  margin-left: 10px;
  cursor: pointer;
  color: #6b7280;
}

/* BOTTOM */
.file-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-size: 12px;
  color: #6b7280;
}

/* AVATAR */
.avatar-sm {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

/* BUTTON */
.btn-orange {
  background: #f97316;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 6px;
  cursor: pointer;
}

/* MOBILE */
@media (max-width: 768px) {
  .file-card {
    padding: 10px;
  }
}`
        }
      </style>
    </Card>
  );
};

export default FilesSection;